import axios from 'axios';

export const postSubscription = (device) => {
  return axios.post('/devices', { device })
    .then(res => res.data)
    .catch(() => {});
};
